import Backbone from 'backbone/backbone'
import _ from 'underscore/underscore'

import PageView from 'front/components/PageView/PageView.js'
import Contacts from 'front/components/Contacts/Contacts.js'
import Hero from 'front/components/Hero/Hero.js'
import Video from 'front/components/Video/Video.js'

import './ContactsPage.css'
import template from './ContactsPage.jinja'


var ContactsPage = PageView.extend({
    el: '.ContactsPage',

    type: 'Contacts',

    template: template,

    apiUrl: '/api/pages/contacts/',

    playIn() {
        this.contacts.activateTitle()
            .then(() => {
                return this.video.playIn()
            })
            .then(() => {
                app.views.nav.activate();
                app.views.cookie.activate();
                this.hero.activateFrame()
                app.views.logo.activate({delay: 500})
                return app.views.langs.activate({delay: 500})
            })
            .then(() => {
                this.contacts.activateInfo()
                app.els.$body.removeClass('u-NoOverflow')
            })
    },

    playOut() {
        app.views.langs.deactivate()
        app.views.logo.deactivate()
        this.contacts.deactivateInfo()

        return Promise.resolve(this.slider.deactivateImage())
            .then(() => {
                this.slider.deactivateTitle()
                return app.views.nav.deactivate()
            })
    },

    prepare () {
        this.$el[0].style.display = 'block'

        this.$video = this.$('.Video')

        this.contacts = this.views.contacts = new Contacts()

        this.hero = this.views.hero = new Hero({
            el: this.$('.Hero')
        })

        this.video = this.views.video = new Video({
            el: this.$video
        })

        $.Velocity.hook(this.$video, 'opacity', '0')
        $.Velocity.hook(this.contacts.$title, 'opacity', '0')
        $.Velocity.hook(this.contacts.$footer, 'opacity', '0')
        $.Velocity.hook(this.contacts.$list, 'opacity', '0')

        return this.preloadImages()
            .then(() => {
                this.video.activate()
            })
            .then(()=> {
                return this.promise
            })
            .then(() => {
                app.els.$window.scrollTop(0)
                return app.loader.deactivate()
            })
    },

    cleanUp () {
        app.els.$body.addClass('u-NoOverflow')
        this.close()
        return app.loader.activate()
    }
})

export default ContactsPage



// WEBPACK FOOTER //
// ./assets/app/front/pages/ContactsPage/ContactsPage.js